class ScrollToReviews extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }
  
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }
  
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }
  
    handleClick() {
      const target = document.querySelector('.yotpo-main-reviews-widget');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
  
  customElements.define('scroll-to-reviews', ScrollToReviews);